import React from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { RootStateOrAny, useSelector } from 'react-redux';

export default function EquipmentDeleteHoldingProfilesButton({
  holdingProfile,
  handleDelete,
}) {
  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  return (
    <div>
      {thisUser.hasHoldingProfileEquipment ? (
        <div onClick={handleDelete(holdingProfile)}>
          <DeleteIcon />
        </div>
      ) : (
        <div>
          <DeleteIcon />
        </div>
      )}
    </div>
  );
}
